import { apiBaseUrl } from "./auth";
import { getStoredLanguage } from "../context/I18nContext";
import i18n from "../i18n";

const RESOURCES_BASE = `${apiBaseUrl}/api/lessons/resources`;

async function request(
  path,
  { accessToken, method = "GET", body, params, isFormData = false } = {},
) {
  const headers = {
    Accept: "application/json",
    "Accept-Language": getStoredLanguage(),
  };

  if (!isFormData) {
    headers["Content-Type"] = "application/json";
  }

  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  const queryParams = params
    ? { ...params, lang: getStoredLanguage() }
    : { lang: getStoredLanguage() };
  const queryString = `?${new URLSearchParams(queryParams).toString()}`;

  const response = await fetch(`${RESOURCES_BASE}${path}${queryString}`, {
    method,
    headers,
    body: body ? (isFormData ? body : JSON.stringify(body)) : undefined,
  });

  const isJson = response.headers
    .get("content-type")
    ?.includes("application/json");
  const payload = isJson ? await response.json() : {};

  if (!response.ok) {
    const message = payload.error || i18n.t("errors.fetchFailed");
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }

  return payload;
}

export function fetchResources({ accessToken, params } = {}) {
  return request("/", { accessToken, params });
}

export function fetchResource({ accessToken, resourceId }) {
  if (!resourceId) throw new Error(i18n.t("errors.fetchFailed"));
  return request(`/${resourceId}/`, { accessToken });
}

export function createResource(accessToken, payload) {
  return request("/", { accessToken, method: "POST", body: payload });
}

export function updateResource(accessToken, resourceId, payload) {
  if (!resourceId) throw new Error(i18n.t("errors.fetchFailed"));
  return request(`/${resourceId}/`, {
    accessToken,
    method: "PATCH",
    body: payload,
  });
}

export function deleteResource(accessToken, resourceId) {
  if (!resourceId) throw new Error(i18n.t("errors.fetchFailed"));
  return request(`/${resourceId}/`, {
    accessToken,
    method: "DELETE",
  });
}

export async function uploadResourceAttachments({
  accessToken,
  resourceId,
  files,
}) {
  if (!resourceId) throw new Error(i18n.t("errors.fetchFailed"));

  const formData = new FormData();
  const list = Array.isArray(files) ? files : [];
  list.forEach((f) => {
    if (f) formData.append("files", f);
  });

  return request(`/${resourceId}/attachments/`, {
    accessToken,
    method: "POST",
    body: formData,
    isFormData: true,
  });
}
